import { KrisenprofitEntry } from '@/model/krisenprofit';

import { DataFetcher } from './fetcher/DataFetcher/index.ts';
import { createEqualCommand, RepositoryNocoDbBase } from './repositoryNocoDbBase.ts';

export interface KrisenprofitSearchParams extends AbstractSearchParams {
  which_crisis?: string;
  who_benefited?: string;
  continents?: string;
  country?: string;
}

export class KrisenprofitRepository extends RepositoryNocoDbBase<KrisenprofitEntry, KrisenprofitSearchParams> {
  protected readonly TABLE_NAME = 'krisenprofit';

  protected readonly API_ROUTE = `${process.env.API_URL}v2/noco/tables/${this.TABLE_NAME}/records`;

  protected readonly META_ROUTE = `${process.env.API_URL}v2/meta/tables/${this.TABLE_NAME}`;

  protected readonly RELEVANCE_FIELD = 'rating';

  protected readonly DATE_FIELD: 'CreatedAt';

  protected readonly STATIC_FILTER = createEqualCommand('publish', 'true');

  protected readonly SELECT_FILTERS: (keyof KrisenprofitEntry)[] = [
    'which_crisis',
    'who_benefited',
    'continents',
    'country'
  ];

  protected readonly SEARCH_FIELDS: (keyof KrisenprofitEntry)[] = [
    'headline_',
    'description',
    'which_crisis',
    'who_benefited',
    'other_crisis',
    'other_benefited',
    'when_profit_achieved',
    'how_high_the_profit'
  ];

  public constructor(_fetcher: DataFetcher) {
    super(_fetcher);
  }
}
